/**
 * Hook for managing investigation plan state.
 *
 * Delegates to a mock or real implementation behind a single flag so the UI
 * stays identical across the swap. See investigation/investigationApi.ts.
 */

import {
  InvestigationPlanApi,
  INVESTIGATION_USE_REAL_API,
} from './investigation/investigationApi';
import { useMockInvestigationPlan } from './investigation/useMockInvestigationPlan';
import { useRealInvestigationPlan } from './investigation/useRealInvestigationPlan';

// INVESTIGATION_USE_REAL_API is a compile-time constant, so exactly one of
// these implementations is ever mounted for the life of the app — the branch
// is stable across renders and does not violate the rules of hooks. Calling
// both would run the real hook's useQuery even in mock mode (and require a
// QueryClient everywhere the mock is used).
export const useInvestigationPlan: (
  caseId: string,
  caseDisplayId: string,
  enabled: boolean,
) => InvestigationPlanApi = INVESTIGATION_USE_REAL_API
  ? useRealInvestigationPlan
  : useMockInvestigationPlan;
